import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectRefinementSetTable(state),
        type: 'refinement-set',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryRefinementSet,
    changeFilter: action.changeFilterRefinementSet,
    toggleSort: action.toggleSortRefinementSet,
    toggleMultiSort: action.toggleMultiSortRefinementSet,
    gotoPage: action.gotoPageRefinementSet,
    initialColumnsVisibility: action.initialTableSettingsRefinementSet,
    toggleColumnVisibility: action.toggleColumnVisibilityRefinementSet,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/RefinementSetSalesOrderSearchContainer.js